
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ChannelContext } from "../../../context/channel";
import colors from '../../../theme/colors';
import TimeIcon from '../../shared/Icons/TimeIcon';

interface StyledThumbProps {
  style?: any;
  color: string;
  state?: string;
  colorTooLight?:boolean;
}

interface IWebnarTitle {
  colorHover: string;
}

type ThumbObject = {
  cover?: string,
  title: string,
  date: string,
};

export interface ISmallThumb {
  object: ThumbObject;
  style?: any;
  color: string;
  onClick?: (obj: ThumbObject) => void;
  state?: string;
}

const DEFAULT_COLOR = 'primary';

const getImage = (image: any) => {
  if (!image) throw new Error(`Invalid image`);
  return image;
};

const StyledThumb = styled.div<StyledThumbProps>`
  text-align: start;
  background-color: transparent;
  width: 100%;
  height: auto;
  display: flex;
  align-items: start;
  justify-content: start;
  gap: 8px;
  margin-bottom: 8px;

  .title-container {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    gap: 8px;
  }

  .image-cover {
    height: 100%;
  }

  .cardCover{
    position: relative;
    left: 0;
    cursor: pointer;
    height: 100%;
    width: 100%; 
    max-width: 122px;
    min-height: 84px;

    .backgroundGradient {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(180deg, ${(props) => props.color}00 0%, ${(props) => props.color}99 100%);
      opacity: 0;

      &:hover{
        opacity: 1;
        transition: .5s;
      }
    }

    img{
      width: 122px;
      height: 84px;
      object-fit: cover;
      object-position: center;
    }

  }

  .dateContainer {
    display: flex;
  }
`;

const WebinarTitle = styled.span<IWebnarTitle>`
  cursor: pointer;
  font-weight: 500;
  :hover {
    color: ${(props) => props.colorHover}
  }
`;
const DateAndHour = styled.span`
  color: ${(props) => props.theme.colors.label};

  ${(props) => props.theme?.mediaQuerie.maxWidth.sm}{
    font-size: 12px;  
  }
`;

export const DEFAULT_THUMB_IMAGE =
  'https://static.eventials.com/static/images/talk_thumb.svg';


export const SmallThumb = ({ object, style, color, onClick, state }: ISmallThumb) => {
  const {data} = React.useContext(ChannelContext)

  const [colorTooLight, setColorTooLight] = useState<boolean>(false);

  useEffect(() => {
    function lightOrDark(color:string){
      const hex = color.replace('#', '');
      const c_r = parseInt(hex.substr(0, 2), 16);
      const c_g = parseInt(hex.substr(2, 2), 16);
      const c_b = parseInt(hex.substr(4, 2), 16);
      const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
      return brightness > 155;
    }

    let colorString = color
    let brightness = lightOrDark(colorString)
    setColorTooLight(brightness)
  }, [color]);

  return (
    <StyledThumb color={color} style={{ ...style }} state={state} colorTooLight={colorTooLight}>
        <div onClick={() => (onClick ? onClick(object) : null)} className="cardCover">
          <div className="backgroundGradient" />
          <img src={getImage(object.cover ? object.cover : DEFAULT_THUMB_IMAGE)} alt={`cover ${object.title}`} className="image-cover"/>
        </div>
        <div className='title-container'>
          <WebinarTitle onClick={() => (onClick ? onClick(object) : null)} colorHover={data.config.colors?.colorPrimary}>
            {object.title}
          </WebinarTitle>
          <div className="dateContainer">
            <TimeIcon fill={state === "recorded" ? data.config.colors.colorPrimary : colors.primary} style={{marginRight: '5px'}}/>
            <DateAndHour>
              {object.date.split("às")[0] + " " + t('date.at', 'às') + " " + object.date.split("às")[1]}
            </DateAndHour>
          </div>
        </div>
    </StyledThumb>
  );
};

SmallThumb.defaultProps = {
  onClick: () => {},
  color: DEFAULT_COLOR,
};